/**
 * The price to show for a membership's next renewal.
 *
 * `next_charge_cents` is what the renewal engine (and Charge now) actually
 * charges: the catalog price less any active promo. `auto_renew_price` is
 * SimpleCirc's imported price, kept as history — showing it as the next
 * charge quoted $39.95 for a $49.95 charge (MAN 28534288, 2026-10-01).
 * It is used only when the engine has no number (PayPal rows, or a plan
 * missing from the catalog), and otherwise noted when it differs.
 */
export function renewalPrice(sub: {
  next_charge_cents: number | null
  auto_renew_price: number | null
}): { amount: number | null; note: string | null } {
  if (sub.next_charge_cents == null) return { amount: sub.auto_renew_price, note: null }
  const amount = sub.next_charge_cents / 100
  const old = sub.auto_renew_price
  const note = old != null && Math.round(old * 100) !== sub.next_charge_cents
    ? `SimpleCirc price was $${old.toFixed(2)}`
    : null
  return { amount, note }
}
